export default __webpack_public_path__ + "static/media/platonic-systems.a4b05685.svg";